export const setupNetwork = async () => {
  const provider = window.ethereum;

  const chainId = 42161; // Arbitrum One chain ID
  const chainHex = `0x${chainId.toString(16)}`;

  const waitForChain = async (chainHexId, timeout = 5000) => {
    const start = Date.now();
    while (Date.now() - start < timeout) {
      try {
        const currentChainId = await provider.request({ method: 'eth_chainId' });
        if (currentChainId === chainHexId) return true;
      } catch (e) {
        console.warn('Waiting for chain to register...', e);
      }
      await new Promise((res) => setTimeout(res, 500));
    }
    return false;
  };

  if (!provider) {
    console.error("Can't setup the Arbitrum network: window.ethereum is undefined");
    return false;
  }

  try {
    // Step 1: Try to switch directly
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: chainHex }],
    });
    return true;
  } catch (switchError) {
    console.log(switchError, "switchError");

    if (switchError.code === 4902) {
      try {
        // Step 2: Add Arbitrum
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId: chainHex,
              chainName: 'Arbitrum One',
              nativeCurrency: {
                name: 'Ether',
                symbol: 'ETH',
                decimals: 18,
              },
              rpcUrls: ['https://arb1.arbitrum.io/rpc'],
              blockExplorerUrls: ['https://arbiscan.io'],
            },
          ],
        });

        // Wait for chain to be registered
        console.log("⏳ Waiting for chain to be available...");
        await waitForChain(chainHex);

        // Step 3: Try switching again
        await provider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: chainHex }],
        });

        return true;
      } catch (addError) {
        console.error(chainId, '❌ Failed to add or switch to the Arbitrum network:', addError);
        if (chainId == 42161) {
          return true
        } else {
          return false;
        }
      }
    } else {
      console.error('❌ Failed to switch to the Arbitrum network:', switchError);
      return false;
    }
  }
};